"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _spauiUtils = require("@tencent/spaui-utils");

var _index = require("../../utils/index");

var _async_pool = require("./async_pool");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isArray = _spauiUtils.utils.isArray,
    isFunction = _spauiUtils.utils.isFunction,
    getVersion = _spauiUtils.utils.getVersion;
var ieVersion = getVersion();
var useFileAPI = ieVersion <= -1 || ieVersion >= 10; // 默认id

var genUniqueId = function genUniqueId() {
  return (0, _spauiUtils.uniqueId)('spaui-base-uploader');
};

var uploadXhrMap = {};

var getUploadFiles = function getUploadFiles(event) {
  var getFiles = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && _typeof(window.FileAPI) === 'object' && window.FileAPI.getFiles;
  return getFiles ? getFiles(event) : [];
};
/**
 * @class
 */


var DOMComponent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DOMComponent, _PureComponent);

  function DOMComponent(props) {
    var _this;

    _classCallCheck(this, DOMComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DOMComponent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onClickFileInput", function (event) {
      event.target.value = null;
    });

    _defineProperty(_assertThisInitialized(_this), "abort", function () {
      var _this$props$instanceI = _this.props.instanceId,
          instanceId = _this$props$instanceI === void 0 ? 'unknow' : _this$props$instanceI;
      var uploadXhrList = uploadXhrMap[instanceId] || [];

      if (isArray(uploadXhrList) && uploadXhrList.length > 0) {
        uploadXhrList.forEach(function (item) {
          if (item && _typeof(item) === 'object') {
            if (isFunction(item.abort)) {
              item.abort();
            }
          }
        });
      }
    });

    _this.id = genUniqueId(); // 加载依赖的js

    _this.haveUploaderJS = false;
    (0, _index.addUploaderJs)(function () {
      _this.haveUploaderJS = true;
    }); // 添加input的结构

    _this.el = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.createElement('div'); // ref应用

    _this.refList();

    _this.handleFileChange = _this.handleFileChange.bind(_assertThisInitialized(_this));
    _this.startUpload = _this.startUpload.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DOMComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // 添加结构
      var body = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementsByTagName('body')[0];
      body.appendChild(this.el);

      if (typeof _reactDom.createPortal === 'undefined') {
        this.renderInputFile();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // 添加结构
      if (typeof _reactDom.createPortal === 'undefined') {
        this.renderInputFile();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props$unmountIn = this.props.unmountInactiveInput,
          unmountInactiveInput = _this$props$unmountIn === void 0 ? true : _this$props$unmountIn;

      if (unmountInactiveInput) {
        // 去除结构
        if (typeof _reactDom.createPortal === 'undefined') {
          (0, _reactDom.unmountComponentAtNode)(this.el);
        }

        var body = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.getElementsByTagName('body')[0];
        body.removeChild(this.el);
      }

      this.refList();
    } // ref引用

  }, {
    key: "refList",
    value: function refList() {
      this.input = null;
    }
  }, {
    key: "genInputFile",
    // 生成input输入框
    value: function genInputFile() {
      var _this2 = this;

      var fileId = this.props.fileId;
      var key = fileId || "".concat(this.id, "_inputfile");
      var _this$props = this.props,
          multiple = _this$props.multiple,
          accept = _this$props.accept,
          inputRef = _this$props.inputRef;

      var theInputRef = function theInputRef(el) {
        _this2.input = el;

        if (typeof inputRef !== 'undefined') {
          inputRef(el);
        }
      };

      var inputStyle = {
        width: '0px',
        height: '0px',
        visibility: 'hidden',
        position: 'fixed',
        top: '-9999px',
        left: '-99999px'
      };
      var inputProps = {};
      inputProps.multiple = multiple;

      if (typeof accept !== 'undefined') {
        inputProps.accept = accept;
      }

      return _react["default"].createElement("input", _extends({
        key: key,
        id: key,
        type: "file",
        ref: theInputRef,
        style: inputStyle,
        onChange: this.handleFileChange,
        onClick: this.onClickFileInput
      }, inputProps));
    } // react 15渲染输入框

  }, {
    key: "renderInputFile",
    value: function renderInputFile() {
      (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, // 代表当前组件
      this.genInputFile(), // 塞进传送门的JSX
      this.el // 传送门另一端的DOM node
      );
    } // input type file变更回调

  }, {
    key: "handleFileChange",
    value: function handleFileChange(event) {
      var _this$props2 = this.props,
          onFileChange = _this$props2.onFileChange,
          _this$props2$autoUplo = _this$props2.autoUpload,
          autoUpload = _this$props2$autoUplo === void 0 ? true : _this$props2$autoUplo,
          imageIndex = _this$props2.imageIndex;
      var el = event.currentTarget || event; // 支持自动上传才触发

      if (autoUpload) {
        if (!useFileAPI) {
          this.networkUploadFile(event);
        } else {
          if (el.value) {
            this.uploadFile(event);
          }
        }
      }

      if (isFunction(onFileChange)) {
        onFileChange(event, false, imageIndex, getUploadFiles(event));
      }
    } // 外部调用触发上传

  }, {
    key: "startUpload",
    value: function startUpload() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var customFiles = arguments.length > 2 ? arguments[2] : undefined;

      if (this.input) {
        if (!useFileAPI) {
          this.networkUploadFile(this.input, data, headers);
        } else {
          this.uploadFile(this.input, data, headers, customFiles);
        }
      }
    } // 外部调用触发上传
    // 中断上传

  }, {
    key: "networkUploadFile",
    // 不支持fileapi的上传
    value: function networkUploadFile(event) {
      var _this3 = this;

      var uploadOtherParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props3 = this.props,
          name = _this$props3.name,
          url = _this$props3.url,
          data = _this$props3.data,
          onUpload = _this$props3.onUpload,
          onComplete = _this$props3.onComplete,
          check = _this$props3.check,
          setUrl = _this$props3.setUrl;
      var fileTarget = event.target || event; // 检验完进行下一步上传

      var next = function next() {
        var uploadConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var newFileInfo = arguments.length > 1 ? arguments[1] : undefined;
        var _uploadConfig$data = uploadConfig.data,
            nextData = _uploadConfig$data === void 0 ? {} : _uploadConfig$data;
        var fileId = _this3.props.fileId || "".concat(_this3.id, "_inputfile");
        var finalData = typeof data === 'function' ? data(fileTarget) || {} : data;
        var uploadData = (0, _spauiUtils.objectAssign)(finalData, uploadOtherParams, nextData); // 存储上传信息

        uploadData._file = {};
        uploadData._file[name] = newFileInfo || fileTarget;

        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && _typeof(window.NETWORK) === 'object') {
          // 触发下上传开始回调
          if (isFunction(onUpload)) {
            onUpload(event, {}, true);
          }

          var finalUrl = typeof setUrl === 'function' ? setUrl(fileTarget) : url;
          window.NETWORK["default"].uploader(finalUrl, uploadData, function (response) {
            if (isFunction(onComplete)) {
              onComplete(false, response, response, fileTarget, fileId);
            }
          }, {
            errcbFn: function errcbFn() {
              if (isFunction(onComplete)) {
                onComplete(true, {}, {}, fileTarget, fileId);
              }
            }
          });
        }
      };

      if (isFunction(check)) {
        check(fileTarget, next, []);
      } else {
        next();
      }
    } // 支持fileapi的上传方式

  }, {
    key: "uploadFile",
    value: function uploadFile(event) {
      var _this4 = this;

      var uploadOtherParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var uploadOtherHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var customFiles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var _this$props4 = this.props,
          name = _this$props4.name,
          url = _this$props4.url,
          _this$props4$data = _this$props4.data,
          data = _this$props4$data === void 0 ? {} : _this$props4$data,
          onUpload = _this$props4.onUpload,
          onProgress = _this$props4.onProgress,
          onComplete = _this$props4.onComplete,
          filter = _this$props4.filter,
          check = _this$props4.check,
          _this$props4$headers = _this$props4.headers,
          headers = _this$props4$headers === void 0 ? {} : _this$props4$headers,
          _this$props4$FileAPIC = _this$props4.FileAPIConfig,
          FileAPIConfig = _this$props4$FileAPIC === void 0 ? {} : _this$props4$FileAPIC,
          _this$props4$instance = _this$props4.instanceId,
          instanceId = _this$props4$instance === void 0 ? 'unknow' : _this$props4$instance,
          _this$props4$abortTri = _this$props4.abortTriggerComplete,
          abortTriggerComplete = _this$props4$abortTri === void 0 ? false : _this$props4$abortTri,
          setUrl = _this$props4.setUrl,
          _this$props4$uploadPo = _this$props4.uploadPoolSize,
          uploadPoolSize = _this$props4$uploadPo === void 0 ? 100 : _this$props4$uploadPo;
      var getFiles = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && _typeof(window.FileAPI) === 'object' && window.FileAPI.getFiles;
      var files = []; // 支持从外部传入 files, 用户可能需要多次添加文件再一起上传

      if (isArray(customFiles) && customFiles.length > 0) {
        files = customFiles;
      } else {
        files = getFiles ? getFiles(event) : [];
      }

      var genNext = function genNext(item, resolve) {
        var next = function next() {
          var uploadConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var newFileInfo = arguments.length > 1 ? arguments[1] : undefined;
          var _uploadConfig$data2 = uploadConfig.data,
              nextData = _uploadConfig$data2 === void 0 ? {} : _uploadConfig$data2,
              _uploadConfig$headers = uploadConfig.headers,
              nextHeaders = _uploadConfig$headers === void 0 ? {} : _uploadConfig$headers;
          var uploadFiles = {};
          uploadFiles[name] = newFileInfo || item;

          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.FileAPI) {
            var fileId = _this4.props.fileId || "".concat(_this4.id, "_inputfile");
            var finalUrl = typeof setUrl === 'function' ? setUrl(item) : url;
            var finalData = typeof data === 'function' ? data(item) || {} : data;
            var uploadXhr = window.FileAPI.upload(_objectSpread({
              url: finalUrl,
              data: (0, _spauiUtils.objectAssign)(finalData, uploadOtherParams, nextData),
              files: uploadFiles,
              headers: (0, _spauiUtils.objectAssign)(headers, uploadOtherHeaders, nextHeaders),
              upload: function upload() {
                if (isFunction(onUpload)) {
                  onUpload(event, item, fileId, uploadXhr);
                }
              },
              progress: function progress(progressEvent) {
                if (isFunction(onProgress)) {
                  onProgress(progressEvent, item, fileId);
                }
              },
              complete: function complete(err) {
                var xhr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var status = parseInt(xhr.status, 10) || 0;
                var resp = {};
                var uploadXhrIndex = -1;

                if (status === 200) {
                  try {
                    resp = JSON.parse(xhr.response);
                  } catch (e) {
                    resp = xhr.response;
                  }
                }

                var unTriggerComplete = false;

                if (err === 'abort' && !abortTriggerComplete) {
                  unTriggerComplete = true;
                }

                if (isFunction(onComplete) && !unTriggerComplete) {
                  onComplete(err, xhr, resp, item, fileId);
                }

                if (isArray(uploadXhrMap[instanceId])) {
                  uploadXhrIndex = uploadXhrMap[instanceId].indexOf(uploadXhr);

                  if (uploadXhrIndex > -1) {
                    uploadXhrMap[instanceId][uploadXhrIndex] = null;
                  }
                }

                resolve();
              }
            }, FileAPIConfig));

            if (!uploadXhrMap[instanceId]) {
              uploadXhrMap[instanceId] = [];
            }

            uploadXhrMap[instanceId].push(uploadXhr);
          }
        };

        return next;
      };

      (0, _async_pool.asyncPool)(uploadPoolSize, files, function (item, theFiles) {
        return new Promise(function (resolve) {
          // 筛选不过关的不发起请求
          if (!filter(item, event)) {
            resolve();
            return;
          }

          if (isFunction(check)) {
            check(item, genNext(item, resolve), theFiles);
          } else {
            genNext(item, resolve)();
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props5 = this.props,
          children = _this$props5.children,
          disabled = _this$props5.disabled,
          drag = _this$props5.drag,
          click = _this$props5.click,
          canUpload = _this$props5.canUpload,
          autoUpload = _this$props5.autoUpload,
          _this$props5$dragOver = _this$props5.dragOverClassName,
          dragOverClassName = _this$props5$dragOver === void 0 ? '' : _this$props5$dragOver,
          onFileChange = _this$props5.onFileChange,
          imageIndex = _this$props5.imageIndex;
      var timestamp = new Date().getTime();
      var triggerProps = {};
      var child = null;
      var childProps = {}; // 获取子元素

      if (isArray(children)) {
        // 数组的只取第一个非object的
        children.map(function (item, index) {
          if (!child && typeof item !== 'string') {
            child = (0, _react.cloneElement)(item, {
              key: index
            });
          }

          return item;
        });
      } else {
        child = children;
      }

      if (child && _typeof(child) === 'object' && child.props && _typeof(child.props) === 'object') {
        childProps = child.props || {};
      } // 支持点击上传


      if (click) {
        triggerProps.onClick = function (event) {
          if (canUpload(event) && _this5.haveUploaderJS && !disabled) {
            _this5.input.click();
          }

          if (isFunction(childProps.onClick)) {
            childProps.onClick(event);
          }
        };
      } // 支持拖动上传


      if (drag && useFileAPI && !disabled) {
        triggerProps.onDragLeave = function (event) {
          var targetClassName = '';

          if (event && event.currentTarget) {
            targetClassName = event.currentTarget.className || '';
          }

          event.preventDefault();

          if (dragOverClassName && targetClassName.indexOf(dragOverClassName) > -1) {
            (0, _spauiUtils.removeClassName)(event.currentTarget, dragOverClassName);
          }
        };

        triggerProps.onDrop = function (event) {
          var targetClassName = '';

          if (event && event.currentTarget) {
            targetClassName = event.currentTarget.className || '';
          }

          event.preventDefault();

          if (canUpload(event) && autoUpload) {
            _this5.uploadFile(event);
          } else if (canUpload(event) && !autoUpload && isFunction(onFileChange)) {
            onFileChange(event, true, imageIndex, getUploadFiles(event));
          }

          if (dragOverClassName && targetClassName.indexOf(dragOverClassName) > -1) {
            (0, _spauiUtils.removeClassName)(event.currentTarget, dragOverClassName);
          }
        };

        triggerProps.onDragEnter = function (event) {
          event.preventDefault();
        };

        triggerProps.onDragOver = function (event) {
          var targetClassName = '';

          if (event && event.currentTarget) {
            targetClassName = event.currentTarget.className || '';
          }

          event.preventDefault();

          if (dragOverClassName && targetClassName.indexOf(dragOverClassName) < 0) {
            (0, _spauiUtils.addClassName)(event.currentTarget, dragOverClassName);
          }
        };
      }

      triggerProps.key = "".concat(this.id + timestamp, "_button");

      if (typeof _reactDom.createPortal === 'undefined') {
        return (0, _react.cloneElement)(child, triggerProps);
      } // 因为renderToString不支持createPortal所以要特殊hack一下
      // process.env.SSR 指明是在SSR


      if ((typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object' && process && _typeof(process.env) === 'object' && process.env.SSR) {
        return (0, _react.cloneElement)(child, triggerProps);
      }

      return [(0, _react.cloneElement)(child, triggerProps), (0, _reactDom.createPortal)(this.genInputFile(), this.el)];
    }
  }]);

  return DOMComponent;
}(_react.PureComponent);

var _default = DOMComponent;
exports["default"] = _default;